// src/components/header/gradient-minimalist/hollo-header-gradient-minimalist.ts
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { holloHeaderStyles } from "./hollo-header-styles";
import { penIconSvg, chevronDownIcon, xIcon } from "../../icons";

@customElement("hollo-header-gradient-minimalist")
export class HolloHeaderGradientMinimalist extends LitElement {
  @property({ type: Boolean }) liveCharacter = false;
  @property({ type: String }) currentFlag = ""; // URL of flag image
  @property({ type: Boolean }) showLangMenu = false;
  @property({ type: String }) twinPhoneNumber = "";
  @property({ type: String }) fullName = "";
  @property({ type: String }) profileImageId = "";
  @property({ type: String }) twinPhoneNumberFriendlyForm = "";
  @property({ type: Boolean }) userLoading = false;
  @property({ type: Boolean }) minimalMode = false; // Show only language button

  render() {
    return html`
      <div
        class="hollo-header ${this.minimalMode ? "hollo-header-minimal" : ""}"
      >
        <div class="hollo-left hollo-user">
          <div class="hollo-user-meta">
            <div class="hollo-user-name">
              ${this.userLoading
                ? html`<span class="hollo-skel-name"></span>`
                : html`<span>${this.fullName || ""}</span>`}
            </div>
            ${this.twinPhoneNumber
              ? html`<a
                  class="hollo-user-phone"
                  href="tel:${this.twinPhoneNumber}"
                >
                  ${this.twinPhoneNumberFriendlyForm}
                </a>`
              : null}
          </div>
        </div>
        <div class="hollo-right hollo-actions">
          ${!this.minimalMode
            ? html`
                <button
                  class="hollo-pen-btn"
                  @click=${() =>
                    this.dispatchEvent(new CustomEvent("add-action"))}
                  aria-label="New chat"
                  title="New chat"
                >
                  ${penIconSvg(24, "#000000")}
                </button>
              `
            : null}

          <button
            class="hollo-flag-btn flag-btn"
            @click=${() =>
              this.dispatchEvent(new CustomEvent("toggle-language-menu"))}
            aria-haspopup="menu"
            aria-expanded=${String(this.showLangMenu)}
            title="Choose language"
          >
            <div class="hollo-flag-wrapper">
              ${this.currentFlag
                ? html`<img
                    class="hollo-flag-img"
                    src=${this.currentFlag}
                    alt=""
                    width="32"
                    height="32"
                  />`
                : html`<span class="flag-emoji">🌐</span>`}
              <span class="hollo-chevron-down"
                >${chevronDownIcon(18, "#000000")}</span
              >
            </div>
          </button>
          <button
            class="hollo-menu-btn"
            @click=${() => this.dispatchEvent(new CustomEvent("toggle-menu"))}
            aria-label="close"
            title="Close"
          >
            ${xIcon(24, "#000000")}
          </button>
        </div>
      </div>
    `;
  }

  static styles = holloHeaderStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    "hollo-header-gradient-minimalist": HolloHeaderGradientMinimalist;
  }
}
